var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M88.597 112.207c26.18 0 47.403-13.38 47.403-29.884 0-16.505-4.735-44.116-30.915-44.116-17.95 0-19.945 14.135-36.1 28.27-16.156 14.135-36.857 17.298-44.278 19.706-73.44 23.835 37.71 26.024 63.89 26.024z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.843)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F9CC00",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DEB90F",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CC00",
    d: "M78.389 127C100.266 127 118 110.908 118 91.058S114.043 38 92.167 38C77.167 38 75.5 55 62 72S25 89.46 25 95.7c0 19.85 31.512 31.3 53.389 31.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWave);
export default __webpack_public_path__ + "static/media/yellow-wave.d5bcc7bccc8339de4166f0f9809005da.svg";
export { ForwardRef as ReactComponent };